class CsGrid extends HTMLElement {
    private connected: boolean = false;
    private originalChildren: Element[] = [];

    static get observedAttributes() {
        return ['cols', 'limit'];
    }

    constructor() {
        super();
        this.originalChildren = Array.from(this.children);
    }

    connectedCallback() {
        this.connected = true;
        this.render();
    }

    attributeChangedCallback() {
        if (!this.connected) return;
        this.render();
    }

    render() {
        this.innerHTML = '';

        const limit = Number(this.getAttribute('limit')) || this.originalChildren.length;
        let cols = Number(this.getAttribute('cols')) || 3;

        // Ensure cols do not exceed limit
        cols = Math.min(cols, limit);

        let rowDiv = document.createElement('div');
        rowDiv.className = 'row g-mb-25';

        this.originalChildren.slice(0, limit).forEach((child, index) => {
            if (index % cols === 0) {
                if (rowDiv.children.length) {
                    this.appendChild(rowDiv);
                    rowDiv = document.createElement('div');
                    rowDiv.className = 'row g-mb-25';
                }
            }

            const colDiv = document.createElement('div');
            colDiv.className = `col-md-${12 / cols}`;
            colDiv.appendChild(child.cloneNode(true));
            rowDiv.appendChild(colDiv);
        });

        if (rowDiv.children.length) {
            this.appendChild(rowDiv);
        }
    }
}

customElements.define('cs-grid', CsGrid);
